<style>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@500&display=swap');
body {
  padding: 0;
  margin: 0;
  background-color: #42b983 !important;
  font-family: 'Plus Jakarta Sans', sans-serif;
}
.bg-green {
  background-color: #42b983 !important;
}
.container {
  font-family: 'Plus Jakarta Sans', sans-serif;
}
* {
  scrollbar-width: thin;
  scrollbar-color: #313a14 #008859;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #42b983;
}

*::-webkit-scrollbar-thumb {
  background-color: #008859;
  border-radius: 2px;
  /* border: 0px solid #008859; */
}
</style>

<template>
  <div class="container bg-green">
    <header class="bgimg bg-green text-white">
      <div class="row gx-5">
        <!-- <div class="col-lg-6">
        </div> -->
        <div class="col-lg-6 offset-lg-3">
          <div class="text-center my-5">
            <img src="img/VICTORIA.png" width="33%" class="py-3" />
            <h1 class="display-5 fw-bolder mb-2 py-3">
              Exposición interactiva digital
            </h1>
            <hr />
            <div class="d-grid gap-3 d-sm-flex justify-content-sm-center">
              <a
                class="btn btn-outline-light btn-lg px-4 me-sm-3"
                href="#/game"
              >
                Juego
              </a>
              <a class="btn btn-outline-light btn-lg px-4" href="#/view360">
                Recorrido 360
              </a>
            </div>
          </div>
        </div>
      </div>
    </header>
    <section class="py-5 bg-white border-bottom" id="features">
      <div class="container px-5 my-5">
        <div class="row gx-5">
          <div class="col-lg-6 mb-5 mb-lg-0">
            <h2 class="h4 fw-bolder">Recursos para profesores</h2>
            <p>
              En este apartado podrás acceder a recursos adicionales para el
              mejor aprovechamiento de esta exposición.
            </p>
            <p>
              Si deseas contactarnos, puedes enviar un correo a
              <a target="_blank" href="mailto:museo@upaep.mx">museo@upaep.mx</a>
            </p>
            <ul>
              <li>
                <a href="recursos_pdf/CUADERNILLO_CRONICA.pdf" target="_blank">Cuadernillo para docentes</a>
                <br />
              </li>
              <li>
                <a href="http://bdmx.mx/documento/galeria/ramosyortega-palafoxiana" target="_blank">Diario de Patricio Ramos Ortega</a>
                <br />
              </li>
              <li>
                <a href="recursos_pdf/Glosario.pdf" target="_blank">Glosario</a>
                <br />
              </li>
            </ul>
          </div>
          <div class="col-lg-6 mb-5 mb-lg-0 text-center">
            <img src="img/patrocinadores.png" class="w-50 float-center" />
          </div>
        </div>
      </div>
    </section>
    <wafloater phone="++5212212570586"/>
  </div>
</template>

<script>
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Popper from "@popperjs/core";
import Wafloater from "@/components/Wafloater.vue";

export default {
  name: "Main",
  components: {
    Wafloater
  }
};
</script>
